export const PICKLIST_ADD_TO = "PICKLIST_ADD_TO";
export const PICKLIST_REMOVE_FROM = "PICKLIST_REMOVE_FROM";
export const PICKLIST_CHANGE_QUANTITY = "PICKLIST_CHANGE_QUANTITY";
export const PICKLIST_RENAME = "PICKLIST_RENAME";
export const PICKLIST_DELETE = "PICKLIST_DELETE";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const TOGGLE_SWITCH = "TOGGLE_SWITCH";
export const USER_CustID = "USER_CustID";
export const USER_STATE = "USER_STATE";